import { useEffect } from 'react';
import styled from 'styled-components';

import { RequestSafeReturnFormMeta, RequestSafeReturnFormValues } from 'components/modals/RequestSafeReturnModal';
import ActivityInput from 'components/shared/activityInput/ActivityInput';
import useActivityInput from 'components/shared/activityInput/useActivityInput';
import Button from 'components/shared/Button';
import FieldLabel from 'components/shared/form/FieldLabel';
import { Actions } from 'components/shared/StandardModal';
import { Form, useForm } from 'context/form';
import LocationEpisode from 'models/LocationEpisode';

type SafeReturnFormProps = {
  onCancel: () => void;
  locationEpisode: LocationEpisode;
  noteFieldLabel: string;
  submitButtonText?: string;
};

export default function SafeReturnForm(props: SafeReturnFormProps) {
  const { onCancel, locationEpisode, noteFieldLabel, submitButtonText } = props;

  const { valid, dirty, meta, setMeta, setValue, values } = useForm<
    RequestSafeReturnFormValues,
    RequestSafeReturnFormMeta
  >();

  const { note, setNote } = useActivityInput({ ...values.note });

  useEffect(() => {
    setValue('note', note);
  }, [note, setValue]);

  return (
    <Form>
      <FormContainer>
        <FieldLabel>{noteFieldLabel}</FieldLabel>
        <ActivityInput
          locationEpisodeId={locationEpisode.id}
          values={note}
          setValues={setNote}
          onUploading={(uploading) => setMeta('isUploadingAttachments', uploading)}
        />
      </FormContainer>

      <Actions>
        <Button variant='ghost' type='button' onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type='submit'
          data-cy='clickable'
          disabled={!valid || !dirty || meta.isUploadingAttachments}
          loading={meta.isSubmitting}>
          {submitButtonText || 'Confirm'}
        </Button>
      </Actions>
    </Form>
  );
}

const FormContainer = styled.div`
  margin: 20px 0;
`;
